import React from "react";
import "./HeroWhy.css";
import { useNavigate } from "react-router-dom";
export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="herowhy" id="herowhyw">
      {/* ✅ Overlay for better contrast */}
      <div className="herowhy-overlaywhy"></div>
      <div className="herowhy-contentwhy">
        <h1>Why Choose Glamur <br></br> Paint </h1>
       
        <button className="ctawhy-btnwhy" onClick={() => navigate("/e-store")}>
          BUY YOUR FAVOURITE PAINTS NOW!
        </button>
      </div>
    </section>
  );
}
